import React from 'react'

export default class PreferencesBox extends React.Component {
  renderTable( list ) {
    const rows = list.map((row) => {
      return <tr key={ row.id } >
        <td>{row.category}</td>
        <td>{row.size}</td>
        <td>{row.ttl}</td>
      </tr>
    })
    return rows
  }

  render() {
    let preferencesList = this.props.preferencesList
    return (
      <table className="table table-striped">
        <thead>
        </thead>
        <tbody>
          { this.renderTable(preferencesList) }
        </tbody>
      </table>
    )
  }
}